(function () {
  const VISIBLE_COUNT = 3;
  const GAP = 20;

  function equalizeBlogCards(scope = document) {
    const containers = scope.querySelectorAll
      ? scope.querySelectorAll('.sd-blog__grid, .sd-blog__track')
      : document.querySelectorAll('.sd-blog__grid, .sd-blog__track');

    containers.forEach((container) => {
      const cards = Array.from(container.querySelectorAll('.sd-blog-card')).filter(
        (card) => !card.classList.contains('sd-blog-card--clone')
      );
      cards.forEach((card) => {
        card.style.minHeight = '';
      });

      if (!cards.length) return;

      const maxHeight = Math.max(...cards.map((card) => card.offsetHeight));
      cards.forEach((card) => {
        card.style.minHeight = `${maxHeight}px`;
      });
    });
  }

  class SDBlogCarousel {
    constructor(root, controls) {
      this.root = root;
      this.controls = controls;
      this.viewport = root.querySelector('.sd-blog__viewport');
      this.track = root.querySelector('.sd-blog__track');
      this.cards = Array.from(root.querySelectorAll('.sd-blog-card')).filter(
        (card) => !card.classList.contains('sd-blog-card--clone')
      );
      this.prevButton = controls?.querySelector('.sd-blog__nav--prev');
      this.nextButton = controls?.querySelector('.sd-blog__nav--next');
      this.dotsContainer = controls?.querySelector('.sd-blog__dots');
      this.currentIndex = 0;
      this.maxIndex = Math.max(0, this.cards.length - VISIBLE_COUNT);
      this.mqlDesktop = window.matchMedia('(min-width: 990px)');
      this.dots = [];

      if (this.cards.length <= VISIBLE_COUNT) return;

      this.bindEvents();
      equalizeBlogCards(this.root);
      this.syncMode();
    }

    buildDots() {
      if (!this.dotsContainer || !this.mqlDesktop.matches) return;

      this.dotsContainer.innerHTML = '';

      for (let index = 0; index <= this.maxIndex; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sd-blog__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Aller à l'article ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(dot);
      }

      this.dots = Array.from(this.dotsContainer.querySelectorAll('.sd-blog__dot'));
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => {
        if (this.mqlDesktop.matches) this.goTo(this.currentIndex - 1);
      });
      this.nextButton?.addEventListener('click', () => {
        if (this.mqlDesktop.matches) this.goTo(this.currentIndex + 1);
      });

      this.onResize = () => {
        equalizeBlogCards(this.root);
        this.syncMode();
      };
      window.addEventListener('resize', this.onResize);

      this.onKeydown = (event) => {
        if (!this.mqlDesktop.matches) return;
        if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
        if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
      };

      this.root.addEventListener('keydown', this.onKeydown);
    }

    syncMode() {
      if (this.mqlDesktop.matches) {
        this.buildDots();
        this.goTo(this.currentIndex, false);
        return;
      }

      if (this.dotsContainer) {
        this.dotsContainer.innerHTML = '';
      }
      this.dots = [];

      if (this.track) {
        this.track.style.transform = '';
      }
    }

    goTo(index, animate = true) {
      const nextIndex = Math.min(Math.max(index, 0), this.maxIndex);
      this.currentIndex = nextIndex;

      if (!this.mqlDesktop.matches) {
        return;
      }

      if (!this.track || !this.cards[0]) return;

      const cardWidth = this.cards[0].offsetWidth;
      const offset = nextIndex * (cardWidth + GAP);

      if (!animate) {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(-${offset}px)`;

      if (!animate) {
        this.track.getBoundingClientRect();
        this.track.style.transition = '';
      }

      this.updateControls();
    }

    updateControls() {
      if (!this.mqlDesktop.matches) return;

      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex === this.maxIndex;
      }

      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('sd-blog__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    destroy() {
      window.removeEventListener('resize', this.onResize);
      this.root.removeEventListener('keydown', this.onKeydown);
    }
  }

  class SDBlogMobileControls {
    constructor(section) {
      this.section = section;
      this.scroller = section.querySelector('.sd-blog__grid, .sd-blog__track');
      this.controls = section.querySelector('[data-sd-blog-controls]');
      this.prevButton = this.controls?.querySelector('.sd-blog__nav--prev');
      this.nextButton = this.controls?.querySelector('.sd-blog__nav--next');
      this.dotsContainer = this.controls?.querySelector('.sd-blog__dots');
      this.currentIndex = 0;
      this.dots = [];
      this.active = false;
      this.settleTimer = null;

      this.mql = window.matchMedia('(max-width: 749px)');
      this.onMedia = () => this.sync();
      this.onScroll = () => {
        window.clearTimeout(this.settleTimer);
        this.settleTimer = window.setTimeout(() => this.syncFromScroll(), 80);
      };

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.onMedia);
      } else if (this.mql.addListener) {
        this.mql.addListener(this.onMedia);
      }

      this.sync();
    }

    getCards() {
      if (!this.scroller) return [];

      return Array.from(this.scroller.children).filter(
        (el) => el.classList.contains('sd-blog-card') && !el.classList.contains('sd-blog-card--clone')
      );
    }

    sync() {
      if (this.mql.matches && this.getCards().length > 1) {
        this.enable();
      } else {
        this.disable();
      }
    }

    buildDots() {
      if (!this.dotsContainer) return;

      const cards = this.getCards();
      this.dotsContainer.innerHTML = '';

      cards.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sd-blog__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Aller à l'article ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(dot);
      });

      this.dots = Array.from(this.dotsContainer.querySelectorAll('.sd-blog__dot'));
    }

    bindEvents() {
      this.onPrev = () => this.goTo(this.currentIndex - 1);
      this.onNext = () => this.goTo(this.currentIndex + 1);

      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
    }

    unbindEvents() {
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.scroller?.removeEventListener('scroll', this.onScroll);
      window.clearTimeout(this.settleTimer);
    }

    enable() {
      if (this.active) {
        this.buildDots();
        this.syncFromScroll();
        return;
      }

      this.active = true;
      this.buildDots();
      this.bindEvents();
      equalizeBlogCards(this.section);
      this.syncFromScroll();
    }

    disable() {
      if (!this.active) return;

      this.active = false;
      this.unbindEvents();

      if (this.dotsContainer) {
        this.dotsContainer.innerHTML = '';
      }

      this.dots = [];
    }

    goTo(index) {
      const cards = this.getCards();
      const maxIndex = cards.length - 1;
      const nextIndex = Math.min(Math.max(index, 0), maxIndex);
      const card = cards[nextIndex];

      if (!card || !this.scroller) return;

      const offset = card.offsetLeft - this.scroller.offsetLeft;

      this.scroller.scrollTo({
        left: offset,
        behavior: 'smooth',
      });

      this.currentIndex = nextIndex;
      this.updateControls();
    }

    syncFromScroll() {
      if (!this.active || !this.scroller) return;

      const cards = this.getCards();
      if (!cards.length) return;

      const scrollLeft = this.scroller.scrollLeft;
      let bestIndex = 0;
      let bestDistance = Infinity;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - this.scroller.offsetLeft - scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      this.currentIndex = bestIndex;
      this.updateControls();
    }

    updateControls() {
      const cards = this.getCards();
      const maxIndex = Math.max(0, cards.length - 1);

      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex === maxIndex;
      }

      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('sd-blog__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    onResize() {
      if (!this.active) return;
      equalizeBlogCards(this.section);
      this.buildDots();
      this.goTo(this.currentIndex);
    }

    destroy() {
      this.disable();

      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onMedia);
      } else if (this.mql.removeListener) {
        this.mql.removeListener(this.onMedia);
      }
    }
  }

  class SDBlogTabletLoop {
    constructor(section) {
      this.section = section;
      this.scroller = section.querySelector('.sd-blog__track, .sd-blog__grid');
      this.active = false;
      this.jumping = false;
      this.clones = [];
      this.originals = [];
      this.settleTimer = null;

      this.mql = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
      this.onMedia = () => this.sync();
      this.onScroll = () => {
        if (this.jumping) return;
        window.clearTimeout(this.settleTimer);
        this.settleTimer = window.setTimeout(() => this.settle(), 120);
      };

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.onMedia);
      } else if (this.mql.addListener) {
        this.mql.addListener(this.onMedia);
      }
    }

    sync() {
      if (this.mql.matches) {
        this.enable();
      } else {
        this.disable();
      }
    }

    makeClones() {
      return this.originals.map((card) => {
        const clone = card.cloneNode(true);
        clone.classList.add('sd-blog-card--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, [tabindex]').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
        return clone;
      });
    }

    enable() {
      if (this.active || !this.scroller) return;

      this.originals = Array.from(this.scroller.children).filter((el) =>
        el.classList.contains('sd-blog-card')
      );

      if (this.originals.length === 0) return;

      this.active = true;

      const leadFragment = document.createDocumentFragment();
      const trailFragment = document.createDocumentFragment();
      const lead = this.makeClones();
      const trail = this.makeClones();

      lead.forEach((clone) => leadFragment.appendChild(clone));
      trail.forEach((clone) => trailFragment.appendChild(clone));

      this.scroller.insertBefore(leadFragment, this.originals[0]);
      this.scroller.appendChild(trailFragment);
      this.clones = lead.concat(trail);

      equalizeBlogCards(this.section);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

      window.requestAnimationFrame(() => this.centerOriginal(0));
    }

    disable() {
      if (!this.active) return;

      this.active = false;
      this.scroller.removeEventListener('scroll', this.onScroll);
      window.clearTimeout(this.settleTimer);

      this.clones.forEach((clone) => clone.remove());
      this.clones = [];
      this.scroller.scrollLeft = 0;

      equalizeBlogCards(this.section);
    }

    centerCard(card) {
      if (!card) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const delta =
        cardRect.left + cardRect.width / 2 - (scrollerRect.left + this.scroller.clientWidth / 2);

      const previous = this.scroller.style.scrollBehavior;
      this.scroller.style.scrollBehavior = 'auto';
      this.scroller.scrollLeft += delta;
      this.scroller.style.scrollBehavior = previous;
    }

    centerOriginal(index) {
      const child = this.scroller.children[this.originals.length + index];
      this.centerCard(child);
    }

    settle() {
      if (!this.active) return;

      const children = Array.from(this.scroller.children);
      const len = this.originals.length;

      if (children.length < len * 3) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const center = scrollerRect.left + this.scroller.clientWidth / 2;

      let bestIndex = 0;
      let bestDistance = Infinity;

      children.forEach((child, index) => {
        const rect = child.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      const setWidth =
        children[len].getBoundingClientRect().left - children[0].getBoundingClientRect().left;

      if (bestIndex < len) {
        this.jumpBy(setWidth);
      } else if (bestIndex >= len * 2) {
        this.jumpBy(-setWidth);
      }
    }

    jumpBy(delta) {
      if (!delta) return;

      this.jumping = true;
      const previous = this.scroller.style.scrollBehavior;
      this.scroller.style.scrollBehavior = 'auto';
      this.scroller.scrollLeft += delta;
      this.scroller.style.scrollBehavior = previous;

      window.requestAnimationFrame(() => {
        this.jumping = false;
      });
    }

    recenterNearest() {
      const children = Array.from(this.scroller.children);
      if (!children.length) return;

      const scrollerRect = this.scroller.getBoundingClientRect();
      const center = scrollerRect.left + this.scroller.clientWidth / 2;

      let best = null;
      let bestDistance = Infinity;

      children.forEach((child) => {
        const rect = child.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = child;
        }
      });

      this.centerCard(best);
    }

    onResize() {
      if (!this.active) return;
      equalizeBlogCards(this.section);
      this.recenterNearest();
    }

    destroy() {
      this.disable();

      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this.onMedia);
      } else if (this.mql.removeListener) {
        this.mql.removeListener(this.onMedia);
      }
    }
  }

  const instances = new WeakMap();
  const mobileControls = new WeakMap();
  const tabletLoops = new WeakMap();

  function getSections(scope) {
    const sections = [];

    if (scope && scope.nodeType === 1 && scope.matches && scope.matches('.sd-blog')) {
      sections.push(scope);
    }

    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('.sd-blog').forEach((section) => sections.push(section));
    }

    return sections;
  }

  function setupTabletLoop(section) {
    let loop = tabletLoops.get(section);

    if (!loop) {
      loop = new SDBlogTabletLoop(section);
      tabletLoops.set(section, loop);
    }

    loop.sync();
  }

  function setupMobileControls(section) {
    let controls = mobileControls.get(section);

    if (!controls) {
      controls = new SDBlogMobileControls(section);
      mobileControls.set(section, controls);
    }

    controls.sync();
  }

  function initCarousel(root) {
    if (!root) return;

    const existing = instances.get(root);
    if (existing) {
      existing.destroy();
      instances.delete(root);
    }

    const controls = root.parentElement?.querySelector('[data-sd-blog-controls]');
    const instance = new SDBlogCarousel(root, controls);
    instances.set(root, instance);
  }

  function initAll(scope = document) {
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-sd-blog-carousel]').forEach(initCarousel);
    }

    getSections(scope).forEach((section) => {
      setupTabletLoop(section);
      setupMobileControls(section);
    });

    equalizeBlogCards(scope);
  }

  function onResize() {
    equalizeBlogCards();
    document.querySelectorAll('.sd-blog').forEach((section) => {
      const loop = tabletLoops.get(section);
      if (loop) loop.onResize();

      const controls = mobileControls.get(section);
      if (controls) controls.onResize();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-sd-blog-carousel]').forEach((root) => {
        const instance = instances.get(root);
        if (instance) {
          instance.destroy();
          instances.delete(root);
        }
      });
    }

    getSections(event.target).forEach((section) => {
      const loop = tabletLoops.get(section);
      if (loop) {
        loop.destroy();
        tabletLoops.delete(section);
      }

      const controls = mobileControls.get(section);
      if (controls) {
        controls.destroy();
        mobileControls.delete(section);
      }
    });
  });
})();
